// extracted by mini-css-extract-plugin
module.exports = {"container":"_3pBpM","titleRow":"BeDzz","title":"_2FmtP","viewItems":"_3oasl","spreadRow":"_346gm","total":"_1kSjZ"};